document.addEventListener(
  'DOMContentLoaded',
  () => {
    purchaseAsses();
  },
  false
);

const faqList = document.querySelector('.faq__list') || null;

if (faqList) {
  faqList.addEventListener('click', function(e) {
    let item = e.target;

    if (item.classList.contains('faq__item')) {
      item.classList.toggle('toggled');
    }
  });
}

const purchaseAsses = () => {
  let assessment_actions = document.querySelector('.easy__assessment');
  let btn_check = assessment_actions.querySelector('.assessment_check');
  let result_section = assessment_actions.querySelector('.easy__assessment-text');

  btn_check.addEventListener('click', function() {
    let receivable = document.querySelector('.assessment_receivable').value;
    let payment = document.querySelector('.assessment_payment').value;
    let quotation = document.querySelector('input[name="quotation"]').checked;
    let timing = document.querySelector('input[name="timing"]').checked;

    if(receivable >= 100) {
      //Payment
      if(payment == 1) {
        payment = 0.04;
      }
      else if(payment == 3) {
        payment = 0.02;
      }
      else if(payment == 6) {
        payment = 0;
      }
      else {
        alert('問題があるようですので、ブラウザを再読み込みしてください');
        return 0;
      }

      //Quotation
      if(quotation == true) {
        quotation = 0.02;
      }
      else if(quotation == false) {
        quotation = 0;
      }
      else {
        alert('問題があるようですので、ブラウザを再読み込みしてください');
        return 0;
      }

      //Default
      if(timing == true) {
        timing = 0.11;
      }
      else if(timing == false) {
        timing = 0.1;
      }
      else {
        alert('問題があるようですので、ブラウザを再読み込みしてください');
        return 0;
      }

      assessment_actions.classList.add('easy__assessment--active');
      let lower_limit = receivable - (receivable * (timing - quotation - payment));
      let upper_limit = receivable * 0.99;
      let result = "取金額<span>"+ parseInt(lower_limit) +"</span>~<span>"+ parseInt(upper_limit) +"</span>万円";
      result_section.innerHTML = result;
    }
    else
      alert('100万円以上の請求金額を入力してください');
    
    btn_check.querySelector('p').innerHTML = 'もう一度査定してみる';
  });
}

// const btnAssessment = document.querySelector('.easy__assessment-box') || null;

// if (btnAssessment) {
//   btnAssessment.addEventListener('click', function(e) {
//     e.preventDefault();

//     e.target.textContent = e.target.dataset.text;
//   });
// }

const toTop = document.querySelector('.page-top') || null;

if (toTop) {
  toTop.addEventListener('click', function(e) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });

  window.addEventListener('scroll', function(e) {
    if (window.pageYOffset > 150) {
      toTop.classList.add('scrolled');
    } else {
      toTop.classList.remove('scrolled');
    }
  });
}
